import Model from './about_component_model';
import DOM from '../../../../utils/dom';
import BaseOptionsComponentController from "../base_options_component_controller";
import {SYSTEM_EVENTS, USER_EVENTS} from '../../../../events/events';
import Event from '../../../../utils/event';
import _ from '../../../../utils/underscore';
import {REGULATION_CODE_TYPES} from '../../../../services/regulation/regulation_const';
import {GNWP_SOURCES} from "../../../external_links/external_links_consts";
import * as EXTERNAL_LINKS_CONSTS from "../../../external_links/external_links_consts";

// Views
let aboutView = require('./view/about.html');

/**
 * Component allows to view user information for support reasons. CID - id for support and Client Version
 */
class AboutController extends BaseOptionsComponentController {

    static CLASS = 'AboutController';

    /**
     * @property
     * @type {object|null}
     * @private
     */
    _model = null;

    /**
     *`
     * @param params
     */
    init(params) {
        super.init();
        this._model = Model.create(this._initParams());
    }

    _initParams() {
        let params = {};
        params.cid = this.serviceFactory.userService().getCID();
        params.clientVersion = this.serviceFactory.skinService().getVersion();
        params.taxID = this.serviceFactory.userService().getTaxID();

        return params;
    }


    /**
     * Start the component view.
     *
     *
     * @returns {AboutController}
     * @public
     */
    start() {
        let bakedHTML = this.bake(aboutView);
        this.setHTML(bakedHTML);
        this._prepareHelpText();

        // Should be shown only if you have taxID and in Italy regulation.
        if (_.isNullOrUndefined(this._model.getOptions().taxID) || this.serviceFactory.regulationService().getRegulationCode() !== REGULATION_CODE_TYPES.ITALY) {
          this.getEl().querySelector('.cgp-about-fiscal-code').style.display = 'none';
        }

        // Should be shown only if you in Portugal regulation.
        if (this.serviceFactory.regulationService().showSessionBalanceInAboutBox()) {
            return this.serviceFactory.openSessionsService().getPlayerOpenSessionsBalance().then((data)=> {
                DOM.text(this.querySelector('.cgp-about-session-balance-amount'), this.serviceFactory.currencyService().formatMoney(data));
                return this;
                });
        } else {
              this.getEl().querySelector('.cgp-about-open-session-balance-code').style.display = 'none';
              return this;
        }
    }

    _prepareHelpText() {

        // We don't want the help text inside the CIP8/ unsupported regulations about window.
        if (this.serviceFactory.integrationService().isMiniOrbit() || !this.serviceFactory.regulationService().showHelpInAboutWindow()) {
            return;
        }

        this._translateAboutHelp();
        this.onChildElementEvent('.cgp-about-help a', USER_EVENTS.ON_CLICK, () => {
          this.serviceFactory.openLinkService().openLink({
            source: GNWP_SOURCES.HELP,
            view: EXTERNAL_LINKS_CONSTS.NAVIGATION_VIEWS.WINDOW
          });
          Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, {category: 'Client_About', action: 'Help'});
        });
    }

    _translateAboutHelp() {
        let aboutHelpTranslation = this.translate('about_help_support', {
            anchorStart: `<a id="cgp-about-help-link" class="cgp-themes-link">`,
            anchorEnd: '</a>'
        });
        DOM.html(aboutHelpTranslation, this.getEl().querySelectorAll('.cgp-about-help')[0]);
    }

    /**
     * Handle after component open action
     * @protected
     */
    onComponentOpened() {
        Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, {category: 'Client_About', action: 'Open'});
    }


    /**
     * Get title language key
     * @returns {string}
     * @private
     */
    _getTitleKey() {
        return 'about_title';
    }

    _getCustomCSSClassList() {
        return super._getCustomCSSClassList().concat(['cgp-options-about']);
    }


    /**
     * Callback fired when component is completly removed from DOM
     * @protected
     */
    onComponentClosed() {
        super.onComponentClosed();
        Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, {category: 'Client_About', action: 'Close'});
    }

}

export default AboutController;

